import React from 'react';
import Input from '../../../components/ui/Input';

const TemplateFilters = ({ search, onSearchChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-6 shadow-elevation-sm">
      <Input
        type="search"
        placeholder="Buscar Modelos..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-full max-w-xl"
      />
    </div>
  );
};

export default TemplateFilters;
